export default __webpack_public_path__ + "static/media/Prossimo_evento.cba0be58.jpg";